import React, { useState } from "react";
import { Switch } from "antd";
import { Button, Card, FormCheck, FormControl } from "react-bootstrap";
import ConfirmDelete from "./ConfirmDelete";

interface IConfCampoLivreProps {
  titulo: string;
  multilinha: boolean;
  obrigatorio: boolean;
  onTitleChange: (titulo: string) => void;
  onSwitchChange: (multilinha: boolean) => void;
  onRequiredChange: (required: boolean) => void;
  onDelete: () => void;
}

export function ConfCampoLivre({
  titulo,
  multilinha,
  obrigatorio,
  onTitleChange,
  onSwitchChange,
  onRequiredChange,
  onDelete,
}: IConfCampoLivreProps) {
  return (
    <Card>
      <Card.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Card.Title>Campo Livre</Card.Title>
        <ConfirmDelete onDelete={onDelete} />
      </Card.Header>

      <Card.Body>
        <div className="mb-3">
          <label>Título</label>
          <FormControl
            value={titulo}
            onChange={(e) => onTitleChange(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <Switch checked={multilinha} onChange={onSwitchChange} />
          <span style={{ marginLeft: 10 }}>Multilinha</span>
        </div>

        <FormCheck
          type="checkbox"
          label="Obrigatório"
          checked={obrigatorio}
          onChange={(e) => onRequiredChange(e.target.checked)}
        />
      </Card.Body>
    </Card>
  );
}
